import Marquee from "react-fast-marquee";

const WORDS = [
  "Gratitude", "Prayer", "Fasting", "Bible study", "Community",
  "Testimony", "Discipleship", "Reflection", "Formation", "Scripture",
];

export const EditorialMarquee = () => (
  <section className="py-10 md:py-14 border-y border-ink/10 bg-sage" data-testid="editorial-marquee">
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={`${w}-${i}`} className="flex items-center">
          <span className="font-serif text-3xl md:text-5xl text-ink/80 px-8">{w}</span>
          <span className="text-green text-2xl md:text-3xl">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
